import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import { lang } from '@/lang';
var currentLang = lang.currentLang;
var langfiles = require.context('./lang', true, /\.js$/);
var langfileArr = langfiles.keys().map(function (item) {
  return langfiles(item).default;
});
export default {
  zIndex: 2,
  menus: ['head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'strikeThrough', 'indent', 'lineHeight', 'foreColor', 'backColor', 'link', 'list', 'justify', 'quote', 'image', 'video', 'table', 'code', 'splitLine', 'undo', 'redo'],
  lang: currentLang === 'zh' ? 'zh-CN' : currentLang,
  langTemplate: langfileArr.filter(function (v) {
    return v.lang === currentLang.substring(0, 2);
  })[0].file,
  changeTimeout: 300
};